import { useState } from "react";

import clsx from "clsx";

import { Modal } from "@shared/modal";
import { Video } from "@shared/video";

import breakdownTutorial from "./images/breakdown-tutorial.svg";

interface Props {
  onDismiss: () => void;
}

export const TutorialHeader = ({ onDismiss }: Props) => {
  const [play, setPlay] = useState(false);
  return (
    <>
      <Modal
        size="xl"
        isOpen={play}
        onClose={() => setPlay(false)}
        titleContent={
          <div className="font-bold text-xl">Breakdown Manager Walkthrough</div>
        }
      >
        <Video
          title="Breakdown Manager Walkthrough"
          src="https://www.youtube.com/embed/eKzVi8wWE3E?rel=0&autoplay=1"
        />
      </Modal>
      <div className="flex rounded-xl">
        <div className="w-[20rem] relative">
          <>
            <i
              className={clsx(
                "fa-regular fa-sharp fa-circle-play absolute text-[3rem] text-white",
                "left-[50%] top-[50%] z-[1] py-[0.5rem] px-[0.5rem] hover:text-interstellar",
                "cursor-pointer",
              )}
              style={{ transform: "translate(-50%, -50%)" }}
              onClick={() => setPlay(true)}
            />
            <img
              className="w-full"
              alt="benchmark-marketing-logo"
              src={breakdownTutorial}
            />
          </>
        </div>
        <div className="flex-1 bg-interstellar p-6 rounded-r flex justify-between">
          <div className="flex-1 my-1.5 max-w-[480px]">
            <h3 className="text-white text-2xl">
              Getting started with breakdowns
            </h3>
            <p className="text-sm text-white font-normal">
              Add custom labels to campaigns, adsets, and ads. See your data
              split by anything in your naming convention!
            </p>
          </div>
          <div>
            <button
              className="text-nebula text-xs flex items-center gap-2 mt-[-8px]"
              onClick={onDismiss}
            >
              DISMISS
              <i className="fa-regular fa-xmark text-sm" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
